import { render, staticRenderFns } from "./service-detail.vue?vue&type=template&id=9e89bbea"
import script from "./service-detail.vue?vue&type=script&lang=js"
export * from "./service-detail.vue?vue&type=script&lang=js"
import style0 from "./service-detail.vue?vue&type=style&index=0&id=9e89bbea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports